/**
 * @deprecated
 */
export const toImgix = (string?: string | null): string | undefined => {
  return string;
  /*if (string === undefined || string === null) {
    return undefined;
  }
  const imgixUrl = process.env.IMGIX_URL + '';
  return (
    string.replace(
      new URL(string).origin + '/client/dynamic/images',
      imgixUrl
    ) + '?auto=format%2Ccompress&format=lossless&q=70'
  );*/
};
